import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateRemoveVacancy = {
  removeVacancy: { data: null, loading: false, error: null },
};

export const removeVacancy = createAsyncThunk('user/removeVacancy', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/vacancies/deletion`,
      { vacancies: data },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerRemoveVacancy = {
  [removeVacancy.pending]: (state) => {
    state.removeVacancy.loading = true;
    state.removeVacancy.error = null;
  },
  [removeVacancy.fulfilled]: (state, action) => {
    state.removeVacancy.loading = false;
    state.removeVacancy.data = true;
    state.removeVacancy.error = null;
  },
  [removeVacancy.rejected]: (state, action) => {
    state.removeVacancy.loading = false;
    state.removeVacancy.error = action.payload;
  },
};
